/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloPais from 'Infotrack@Modelos/administracion/pais';
import IPais from 'Infotrack@Modelos/administracion/pais/entidades/pais';

export default class ControladorModeloPais {
    private modeloPais: ModeloPais;
    constructor() {
        this.modeloPais = new ModeloPais();
    }

    public consultarPais() {
        return this.modeloPais.consultarPais().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearPais(pais: IPais) {
        await this.modeloPais.crearPais(pais);
    }

    public async editarPais(pais: IPais) {
        await this.modeloPais.editarPais(pais);
    }

    public async eliminarPais(pais: IPais) {
        await this.modeloPais.eliminarPais(pais);
    }

    public validarEntidad(pais: IPais): boolean {
        if (pais.CodigoPais === '' || pais.NombrePais === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
